(function () {
    'use strict';

    angular
        .module('riskModule')
        .directive('grcRisk', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addRisk = '&';
        directiveScope.unlinkRisk = '&';
        directiveScope.needToLoadAssessments = '=?';
        directiveScope.layoutRatio = '=?';
        directiveScope.highlight = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$modal', '$state', '$controller', '$mdToast', 'grcGovernanceProcessService', 'grcRiskService',
                         function ($rootScope, $scope, $modal, $state, $controller, $mdToast, grcGovernanceProcessService, grcRiskService) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/risk/grcRisk.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || 'GRCRiskManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'Risk';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.ctxtDir = {};
                $scope.ctxtDir.canEdit = $scope.boxPermissions.Edit;
                $scope.readOnly = isReadOnly();

                // Layout
                $scope.getRiskColumn = function () {
                    var defaultRiskColumn = 'col-sm-12';

                    if (_.isUndefined($scope.layoutRatio)) return defaultRiskColumn;
                    if (_.isUndefined($scope.layoutRatio.riskColumn)) return defaultRiskColumn;

                    return $scope.layoutRatio.riskColumn;
                };

                $scope.getAssessmentColumn = function () {
                    var defaultAssessmentColumn = 'col-sm-12';

                    if (_.isUndefined($scope.layoutRatio)) return defaultAssessmentColumn;
                    if (_.isUndefined($scope.layoutRatio.assessmentColumn)) return defaultAssessmentColumn;

                    return $scope.layoutRatio.assessmentColumn;
                };

                $scope.getUnlinkColumn = function () {
                    var defaultUnlinkColumn = '';

                    if (_.isUndefined($scope.layoutRatio)) return defaultUnlinkColumn;
                    if (_.isUndefined($scope.layoutRatio.unlinkColumn)) return defaultUnlinkColumn;

                    return $scope.layoutRatio.unlinkColumn;
                };

                $scope.getBoxClass = function () {
                    var defaultBoxType = 'is-nav',
                        clickable = '';

                    if (!$scope.isBoxClickable) {
                        clickable = ' not-clickable-card';
                    }

                    if (_.isUndefined($scope.layoutRatio)) return defaultBoxType + clickable;
                    if (_.isUndefined($scope.layoutRatio.boxType)) return defaultBoxType + clickable;


                    return $scope.layoutRatio.boxType + clickable;
                };

                if ($scope.needToLoadAssessments) {
                    grcRiskService.getRiskAssessments($scope.boxModel.RiskID)
                        .then(function (riskAssessments) {
                            $scope.boxModel.RiskAssessments = _.take(riskAssessments, 2);
                        });
                }

                // When selected risk
                $scope.whenSelectedRisk = function (risk) {
                    $scope.addRisk({ risk: risk });
                };

                // To unlink risk
                $scope.toUnlinkRisk = function (risk, $event) {
                    $event.stopPropagation();

                    if (!_.isUndefined($scope.unlinkRisk)) {
                        $scope.unlinkRisk()(risk);
                    }
                };

                // Page is dirty
                $scope.ctxtDir.needSaveChanges = false;

                $scope.pageIsDirty = function () {
                    $scope.ctxtDir.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                };
                $scope.pageIsNotDirty = function () {
                    $scope.ctxtDir.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                };

                // Custom Methods
                $scope.groupByRiskClass = function (riskType) {
                    return riskType.RiskClass.TitleEN;
                };

                $scope.orderRiskClass = function (groups) {
                    return _.sortBy(groups, 'name');
                };

                // Show Reset Action?
                $scope.showResetAction = function (form) {
                    return $scope.ctxtDir.needSaveChanges;
                };

                // Reset forms
                $scope.reset = function () {
                    $state.reload();
                };

                // Show save action?
                $scope.showSaveAction = function (form) {
                    if (form.$invalid) return false;
                    
                    return $scope.ctxtDir.needSaveChanges;
                };

                // Save Changes
                $scope.saveChanges = function () {
                    if (!_.isUndefined($scope.boxModel.RiskType)) $scope.boxModel.RiskTypeID = $scope.boxModel.RiskType.RiskTypeID;
                    $scope.boxModel.ItemOrderID = $scope.boxModel.DisplayItemOrderID;

                    grcRiskService
                        .createOrUpdateRisk($scope.boxModel)
                        .then(function (updatedRisk) {

                            if ($state.is('riskKeyOrDeptAdd') || $state.is('riskTopAdd')) {
                                $state.go('riskEdit', { RiskID: updatedRisk.RiskID });
                            }
                            else if (_.isUndefined($scope.boxModel.RiskID)) {
                                $state.go('riskEdit', { RiskID: updatedRisk.RiskID });
                            }
                            else {
                                _.assign($scope.boxModel, updatedRisk);

                                $scope.$broadcast('refreshHistoricOnRisk', null);

                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .content('Your changes have been saved')
                                        .position('top right')
                                        .hideDelay($scope.govNotificationDelay)
                                        .action('OK')
                                        .theme('primary')
                                );

                                $scope.pageIsNotDirty();
                            }
                        });
                };

                // Close Risk
                $scope.closeRisk = function () {
                    grcRiskService
                        .closeRisk($scope.boxModel)
                        .then(function (closedRisk) {
                            _.assign($scope.boxModel, closedRisk);
                            $scope.readOnly = isReadOnly();
                        });
                };

                // Toggle IsSuggested
                $scope.toggleIsSuggested = function () {
                    $scope.boxModel.RecommendClosing = false;
                    $scope.pageIsDirty();
                };

                // Toggle IsSuggested
                $scope.toggleRecommendClosing = function () {
                    $scope.boxModel.IsSuggested = false;
                    $scope.pageIsDirty();
                };

                // Can edit name or description
                $scope.canEditName = function () {
                    if ($scope.readOnly) return false;
                    if (!_.isUndefined($scope.boxModel.RiskLevel) && !$scope.boxModel.RiskLevel.IsDepartmentRisk) return true;

                    return _.isUndefined($scope.boxModel.RiskAssessments) ||
                           $scope.boxModel.RiskAssessments.length === 0 ||
                           $scope.boxModel.RiskAssessments[0].HasFinalAssessorReviewed;
                };
                $scope.canEditDescription = $scope.canEditName;

                // Select Assessor
                $scope.selectAssessor = function (person) {
                    $scope.boxModel.AssessorUser = person;
                    $scope.boxModel.AssessorID = person.ItemPersonID;

                    $scope.pageIsDirty();
                };

                // Is save disabled
                $scope.isSaveDisabled = function () {
                    return $scope.readOnly || ($scope.riskLevel &&
                                                    $scope.riskLevel.IsDepartmentRisk &&
                                                    !$scope.boxModel.AssessorUser);
                };

                function isReadOnly() {
                    return !$scope.ctxtDir.canEdit || ($scope.boxModel && $scope.boxModel.IsClosed);
                }
            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);

                if (!_.isUndefined(scope.boxModel)) {
                    scope.riskLevel = scope.boxModel.RiskLevel;
                }
            }
        }
    }
})();